import React from 'react'
import { useTranslation } from 'react-i18next'
import { Chip } from 'vnetwork-ui'

interface Props {
    employee_status: number
}

const EmployeeStatus: React.FC<Props> = ({ employee_status }) => {
    const { t } = useTranslation()

    return (
        <Chip
            label={
                employee_status === 1
                    ? t('employee-active')
                    : t('employee-stop')
            }
            size="small"
            variant="contained"
            color={employee_status === 1 ? 'success' : 'error'}
        />
    )
}

export default EmployeeStatus
